import { Pipe, PipeTransform } from '@angular/core';
import type { ModuleInterface } from '@zaoblako/shared/modules/security/dtos/access-control/module.dto';

@Pipe({
  name: 'translateModules',
  standalone: true
})
export class TranslateModulesPipe implements PipeTransform {
  public transform(systemNames: string[], modules: ModuleInterface[]): string[] {
    if (!systemNames?.length || !modules?.length) {
      return null;
    }
    return modules
      .filter((module) => systemNames.some((sn) => sn === module.systemName))
      .map((module) => module.displayName);
  }
}
